import React from 'react';

const Roadmap = () => {
  return (
    <div id="fh5co-about" className="animate-box">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>My Road Map</h2>
          </div>
        </div>
        <div className="row">
          <div className="container">
            <div className="col-md-12">
              <img src="images/roadmap.jpeg" style={{width: '100%'}} className="img-fluid mx-auto" alt="Roadmap" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
